import { render, staticRenderFns } from "./HotelDetailHeader.vue?vue&type=template&id=9bf53c6e&scoped=true"
import script from "./HotelDetailHeader.vue?vue&type=script&lang=js"
export * from "./HotelDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./HotelDetailHeader.vue?vue&type=style&index=0&id=9bf53c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf53c6e",
  null
  
)

export default component.exports